import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAuth } from './auth';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize MSAL (and process any sign-in redirect) BEFORE the first render so the app can
// read the signed-in account synchronously. .finally() ensures we still render even if init
// rejects — App handles the no-account case by prompting sign-in.
initAuth().finally(() => {
  root.render(<App />);
});
